(() => {
  const initialiseEditorialPages = (scope = document) => {
    const editorialPages = scope.matches?.('[data-lulu-editorial-page]')
      ? [scope]
      : scope.querySelectorAll('[data-lulu-editorial-page]');
    if (!editorialPages.length) return;

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    editorialPages.forEach((page) => {
      if (page.dataset.luluEditorialInitialised === 'true') return;
      page.dataset.luluEditorialInitialised = 'true';

      const revealItems = page.querySelectorAll('[data-lulu-editorial-reveal]');
      if (!revealItems.length || reducedMotion || !('IntersectionObserver' in window)) {
        revealItems.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      page.classList.add('lulu-editorial--ready');
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.12 },
      );

      revealItems.forEach((item) => observer.observe(item));
    });
  };

  initialiseEditorialPages();

  if (typeof window === 'undefined' || !document.addEventListener) return;
  if (window.luluEditorialPagesControllerBound) return;
  window.luluEditorialPagesControllerBound = true;
  document.addEventListener('shopify:section:load', (event) => initialiseEditorialPages(event.target));
})();
